export const formatToChatNotification = (payload, eventType) => {
  let transformedData = null
  if (eventType === 'customer_sent_message') {
    transformedData = customerSentMessageFormatter(payload)
  } else if (eventType === 'add_agent') {
    transformedData = addAgentNotificationFormatter(payload)
  } else if (eventType === 'resolve_room') {
    transformedData = resolveRoomNotificationFormatter(payload)
  } else if (eventType === 'block_contact') {
    transformedData = blockContactNotificationFormatter(payload)
  } else {
    transformedData = null
  }

  return transformedData || null
}

// eslint-disable-next-line complexity
export const customerSentMessageFormatter = (payload) => {
  if (
    !payload.data ||
    typeof payload.data.room !== 'object' ||
    payload.data.room === null
  ) {
    return null
  }

  const room = payload.data.room
  const notification = {
    id: payload.data.id || '',
    title: payload.data.title || '',
    description: payload.data.description || '',
    click_action: payload.data.click_action || '',
    click_action_url: payload.data.click_action_url || '',
    is_reminder: payload.data.is_reminder ?? false,
    created_at: payload.data.created_at || '',
    read_at: payload.data.read_at || '',
    type: payload.data.type || '',
    status: payload.data.status || '',
    extra: {
      actor_id: '',
      actor_full_name: '',
      agent_id: '',
      agent_name: '',
      channel: room.channel,
      room,
      room_id: room.id,
    },
    notif_type: payload.data.notif_type || '',
    notif_type_label: payload.data.notif_type_label || '',
    notif_category: payload.data.notif_category || '',
    notif_category_label: payload.data.notif_category_label || '',
    origin: payload.data.origin || '',
    organization_id: payload.data.organization_id || '',
    event_id: payload.data.event_id || '',
    event_type: payload.data.event_type || '',
  }

  return notification
}

export const addAgentNotificationFormatter = (payload) => {
  const transformedData = {
    ...payload.data,
    extra: {
      ...payload.data.extra,
      actor_id: '',
      actor_name: '',
      agent_id: '',
      agent_name: '',
    },
  }

  return transformedData || null
}

export const resolveRoomNotificationFormatter = (payload) => {
  const transformedData = {
    ...payload.data,
    extra: {
      ...payload.data.extra,
      actor_id: '',
      actor_name: '',
      agent_id: '',
      agent_name: '',
    },
  }

  return transformedData || null
}

export const blockContactNotificationFormatter = (payload) => {
  const transformedData = {
    ...payload.data,
    extra: {
      ...payload.data.extra,
      actor_id: '',
      actor_name: '',
      agent_id: '',
      agent_name: '',
    },
  }

  return transformedData || null
}
